import { asWidgetProps } from 'Src/types/widget-helpers';
import React, { ComponentProps, forwardRef } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { Title } from 'Components/frameworks/title/Title';
type Props = {
  children: React.ReactNode;
  className?: string;
  hLevel?: number;
  id: string;
  title?: string;
};
export const AccountSection = forwardRef<HTMLElement, Props>(
  ({ children, className, hLevel = 2, id, title }, ref) =>
    children ? (
      <section
        className={classnames('border-t-1 border-lightGrey py-40', className)}
        data-testid={`block-${id}`}
        id={id}
        ref={ref}
      >
        <SiteContainer>
          <Title
            {...asWidgetProps<ComponentProps<typeof Title>>({
              className: 'mb-20 md:mb-30',
              hLevel: hLevel,
              theme: 'title-brand-n1',
            })}
          >
            {title}
          </Title>
          {children}
        </SiteContainer>
      </section>
    ) : null,
);
